import { todayInShanghai } from '@longjie/shared';

export const orderDatePresets = [
  { value: 'day', label: '本日' },
  { value: 'week', label: '本周' },
  { value: 'month', label: '本月' },
] as const;

export type OrderDatePreset = typeof orderDatePresets[number]['value'];

export function orderDateRange(preset: OrderDatePreset, now = new Date()) {
  // Work with Shanghai's calendar date using UTC arithmetic, independent of the device timezone.
  const start = new Date(`${todayInShanghai(now)}T00:00:00.000Z`);
  const end = new Date(start);
  if (preset === 'week') {
    start.setUTCDate(start.getUTCDate() - (start.getUTCDay() + 6) % 7);
    end.setTime(start.getTime());
    end.setUTCDate(end.getUTCDate() + 6);
  } else if (preset === 'month') {
    start.setUTCDate(1);
    end.setUTCMonth(end.getUTCMonth() + 1, 0);
  }
  return { dateFrom: start.toISOString().slice(0, 10), dateTo: end.toISOString().slice(0, 10) };
}
